import React from 'react';
import PropTypes from 'prop-types';

const ObjectTargetNameField = ({ value, onChange, onConfirm }) => (
  <div className="object-name-entry">
    <label htmlFor="object-target-name">Object without a token</label>
    <input
      id="object-target-name"
      type="text"
      value={value}
      autoFocus
      placeholder="e.g. far iron service gate"
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' && value.trim()) {
          event.preventDefault();
          onConfirm();
        }
      }}
    />
    <small>Or click an object token on the map.</small>
  </div>
);

ObjectTargetNameField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ObjectTargetNameField;
